// import { MoreVert } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const PlatformStatsCard = ({ data, handleOptionsClick }: any) => {
  return (
    <Box
      sx={{
        boxShadow: "0px 1px 3px 0px #0000001A",
        p: 2,
        minHeight: "145px",
        bgcolor: "#FFFFFF",
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            minWidth: "60px",
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "12px",
            bgcolor: data?.color,
            mb: 1.5,
            p: 0.5,
          }}
        >
          <Box
            sx={{
              minWidth: "50px",
              p: 1,
              height: "50px",
              borderRadius: "8px",
              border: "2px solid #FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color={"#FFFFFF"} fontWeight={"bold"} variant="h3">
              {data?.value}
            </Typography>
          </Box>
        </Box>
        {/* <Box>
          <IconButton onClick={(e) => handleOptionsClick(e, data)}>
            <MoreVert />
          </IconButton>
        </Box> */}
      </Box>
      <Typography
        sx={{ color: "text.secondary", fontSize: "12px", fontWeight: "600" }}
      >
        {data?.title}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ color: "#1F2A37", fontWeight: "bold" }}
      >
        {data?.desc}
      </Typography>
    </Box>
  );
};

export default PlatformStatsCard;
